import ModalFooter from "@/modules/common/components/ui-kit/modals/modal-footer";
import ModalHeader from "@/modules/common/components/ui-kit/modals/modal-header";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { Backdrop, Box, Modal, ModalProps, SxProps } from "@mui/material";
import { Fade } from "@mui/material";

export interface CommonModalProps extends Omit<ModalProps, "children"> {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  sx?: SxProps;
  onConfirm?: () => void;
  isLoading?: boolean;
  isConfirmDisabled?: boolean;
}

const CommonModal = ({
  open,
  onClose,
  children,
  title,
  cancelButtonText,
  confirmButtonText,
  sx,
  onConfirm,
  isLoading,
  isConfirmDisabled,
  ...props
}: CommonModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      sx={{
        border: "none",
        borderRadius: nawyTheme.nawy.radius["2xl"],
      }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      {...props}
    >
      <Fade in={open}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            flex: "1 0 0",
            borderRadius: nawyTheme.nawy.radius["2xl"],
            background: nawyTheme.nawy.colors.semantic.layer.primary,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            overflow: "hidden",
            ...sx,
          }}
        >
          {title && <ModalHeader title={title} onClose={onClose} />}
          {children}
          {(cancelButtonText || confirmButtonText) && (
            <ModalFooter
              cancelButtonText={cancelButtonText}
              confirmButtonText={confirmButtonText}
              onCancel={onClose}
              onConfirm={onConfirm}
              isLoading={isLoading}
              isConfirmDisabled={isConfirmDisabled}
            />
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default CommonModal;
